import palette from '../palette';

const { blue, white, gray, black, orange, green } = palette;

const colors = {
  Layout: {
    header_background: gray.darker,
    header_color: white.primary,
    link_color: blue.clear,
    content_BGColor: gray.light,
    titleText: black.primary,
    seconday_title: gray.dark,
    notificationRow: white.primary,
    avatarIcon: white.primary,
    clearButtonBG: gray.lighter,
  },
  notificationAvatar: {
    calendar: blue.primary,
    service: orange.primary,
    renewal: gray.darker,
    recall: gray.darker,
    marketPlace: blue.primary,
    reminder: orange.primary,
    home: orange.primary,
    remoteAuth: orange.primary,
    weather: blue.clear,
    sendToCar: gray.darker,
  },
  notificationTypes: {
    calendar: green.primary,
    navigation: blue.primary,
    alert: orange.primary,
  },
  pageBackground: gray.lighter2,
};

export default colors;
